"use strict";
exports.__esModule = true;
exports.feedbackFrequencyInfo = exports.delayInfo = exports.coolDownPeriodInfo = exports.CategoryOptions = exports.REDUCER_ACTIONS = exports.INPUT_META_KEYS = exports.MULTISELECT_KEYS = exports.DEFAULTS = exports.INPUT_BLOCK_KEYS = void 0;
exports.INPUT_BLOCK_KEYS = {
    BUSINESS_NAME: 'name',
    BUSINESS_VIA_NAME: 'via_name',
    PARTNER_LIST: 'partner_list',
    DEFAULT_TEAM: 'default_team',
    LANGUAGES_SUPPORTED: 'languages_supported',
    HUMAN_ASSISTANCE: 'to_assistant',
    SMALL_TALK: 'run_smalltalk',
    FILE_DELETION: 'requests_pii',
    LIVE_AGENT_CHAT_TOOL: 'chat_tool',
    TO_ECT: 'to_ect',
    ACTIVE_BOTS: 'domain_list',
    DEFAULT_BOT: 'default_domain',
    FALLBACK_BOT: 'fallback_domain',
    FILE_UPLOAD_DETAILS: 'file_upload_details',
    IS_CUSTOM_BUCKET_ENABLED: 'is_custom_s3_bucket_enabled',
    CUSTOM_S3_BUCKET_DETAILS: 'custom_s3_bucket_details',
    ALLOWED_S3_REGIONS: 'allowed_s3_regions',
    ALLOWED_OBJECT_ACLS: 'allowed_object_acls',
    BUCKET_ARN: 'bucket_arn',
    S3_BUCKET_NAME: 'bucket_name',
    BUCKET_REGION: 'region',
    EXPIRY: 'expiry',
    OBJECT_ACL: 'acl',
    DIRECTORY: 'directory',
    COLLECT_FEEDBACK: 'collectFeedback',
    MULTIPLE_FEEDBACKS: 'multiple_feedbacks',
    FEEDBACK_DELAY: 'feedback_delay',
    LANGUAGE_CODE: 'language_code',
    PIPELINE_VERSION: 'pipeline_version',
    PREVIEW_TEXT: 'preview_text',
    ORDER: 'order',
};
exports.DEFAULTS = {
    LANGUAGE_CODE: 'en',
    LANGUAGE: 'English',
};
exports.MULTISELECT_KEYS = {
    VALUE: 'value',
};
exports.INPUT_META_KEYS = {
    ALL_BOTS: 'domain_list',
    ALL_LANGUAGES: 'language_list',
    ALL_PARTNERS: 'partner_id_map',
    ALL_TEAMS: 'team_list',
    ALL_TEMPLATE_DOMAINS: 'template_domain_list',
    ALL_CHAT_TOOLS: 'chat_tools',
};
// Action types for reducer
var SET_BUSINESS_DATA = 'SET_BUSINESS_DATA';
var SET_GENERAL_SETTINGS_DATA = 'SET_GENERAL_SETTINGS_DATA';
var SET_BUSINESS_DATA_EDITED = 'SET_BUSINESS_DATA_EDITED';
var SET_LOADER_ACTIVE = 'SET_LOADER_ACTIVE';
var SET_ERROR_LIST = 'SET_ERROR_LIST';
// Reducer Actions
exports.REDUCER_ACTIONS = {
    SET_BUSINESS_DATA: SET_BUSINESS_DATA,
    SET_BUSINESS_DATA_EDITED: SET_BUSINESS_DATA_EDITED,
    SET_GENERAL_SETTINGS_DATA: SET_GENERAL_SETTINGS_DATA,
    SET_LOADER_ACTIVE: SET_LOADER_ACTIVE,
    SET_ERROR_LIST: SET_ERROR_LIST,
};
exports.CategoryOptions = [
    {
        title: 'Bot and agent',
        hint: '1',
    },
    {
        title: 'Only bot',
        hint: '2',
    },
    {
        title: 'Only agent',
        hint: '3',
    },
    {
        title: 'Do not collect feedback',
        hint: '4',
    },
];
exports.coolDownPeriodInfo = "The Cool-Down Period feature lets you specify a timeframe where the Bot won't ask for feedback again after a feedback request has already been made. Please note that this feature is applicable only to interactions with the Bot and does not affect Agent conversations.";
exports.delayInfo = 'The Delay in Seconds setting lets you customise how long the bot waits before triggering feedback, providing users with a seamless conversational experience. Please note that this feature is applicable only to interactions with the Bot and does not affect Agent conversations.';
exports.feedbackFrequencyInfo = 'The Feedback Frequency lets you customise how often the Feedback module will be triggered within a single conversation. Please note that this feature is applicable only to interactions with the Bot and does not affect Agent conversations.';
